<template>
  <div>
    <md-toolbar class="md-transparent md-theme-default md-elevation-0 md-toolbar-filters">
      <div class="md-toolbar-section-start">
        <md-list>
          <md-icon class="md-icon-outlined">filter_alt</md-icon>

          <date-range-picker
            :start="filters.travel_from"
            :end="filters.travel_to"
            @change="changeTravelDate"
            :displayList="true"
            :min-days="1"
            :max-days="maxDays"
            :max-months="3"
            :displayFrom="false"
            :displayTo="false"
            displayFromTo
          >
          </date-range-picker>

          <room-type-select multiple v-model="filters.room_type_ids"></room-type-select>
          <md-field>
            <label>Online/Offline</label>
            <md-select v-model="filters.channels_online">
              <md-option :value="true">Online</md-option>
              <md-option :value="false">Offline</md-option>
            </md-select>
          </md-field>
          <channel-select multiple v-model="filters.channel_ids" :online="filters.channels_online"></channel-select>
          <rate-select multiple v-model="filters.rate_ids"></rate-select>
        </md-list>
        <md-list class="extra_filters">
          <md-switch v-model="filters.include_orr">ORR</md-switch>
          <md-switch v-model="filters.include_tentative">Tentative</md-switch>
          <md-switch v-model="filters.include_guarantees">Guarantees</md-switch>
        </md-list>
      </div>
    </md-toolbar>

    <md-card class="allotment" v-if="data">
      <md-card-content class="allotment-content">
        <div class="card-header">
          <md-button class="md-just-icon arrow-button" :disabled="isPrevPageDisabled" @click="prevPage()">
            <md-icon class="md-icon-font">
              arrow_back
            </md-icon>
          </md-button>
          <md-button class="md-just-icon arrow-button right" :disabled="isNextPageDisabled" @click="nextPage()">
            <md-icon class="md-icon-font">
              arrow_forward
            </md-icon>
          </md-button>
        </div>
        <ValidationObserver ref="validator">
          <md-table class="allotment-table no-w-100" :class="[futureClass, { 'is-non-dirty': futureClass != null }]">
            <md-table-row>
              <md-table-head class="fixed-cell">
                <md-button @click="setFutureLock" class="md-just-icon"><md-icon class="md-icon-outlined">lock</md-icon></md-button>
                <md-button @click="setFutureUnlock" class="md-just-icon"><md-icon class="md-icon-outlined">lock_open</md-icon></md-button>
                <md-button @click="openAdvancedAllotment" class="md-just-icon"><md-icon class="md-icon-outlined">pets</md-icon></md-button>
              </md-table-head>
              <md-table-head
                v-for="(day, index) in days"
                :key="index"
                :class="{
                  h6: true,
                  weekend: isWeekend(day.date),
                }"
              >
                {{ moment(day.date).format('dd DD/MM') }}
                <br />
                <small>{{ day.occ }}%</small></md-table-head
              >
            </md-table-row>
            <allotment-row
              v-for="(channel, index) in rows"
              :key="index"
              :value="rows[index]"
              @allotmentSelected="allotmentSelected"
              :watchers-enabled="watchersEnabled"
            ></allotment-row>
          </md-table>
        </ValidationObserver>
      </md-card-content>
      <md-card-actions>
        <md-button class="md-success" @click="saveSimpleAllotments">Save</md-button>
      </md-card-actions>
    </md-card>

    <allotment-modal v-if="liveModal" ref="modal" v-model="data" @save="saveAdvanceAllotment" :hasSelectedDates="selectionCounter > 0" />
  </div>
</template>

<script>
import AllotmentApi from '../../../openapi/src/api/AllotmentApi'

import AllotmentModal from '../../../components/Allotment/AllotmentBatchModal.vue'
import RoomTypeSelect from '../../../components/Inputs/RoomTypeSelect.vue'
import ChannelSelect from '../../../components/Inputs/ChannelSelect.vue'
import RateSelect from '../../../components/Inputs/RateSelect.vue'
import SimpleAllotmentDTO from '../../../openapi/src/model/SimpleAllotmentDTO'
import SimpleAllotmentActionDTO from '../../../openapi/src/model/SimpleAllotmentActionDTO'
import AdvancedAllotmentActionRequestDTO from '../../../openapi/src/model/AdvancedAllotmentActionRequestDTO'
import { Modal } from '@/components'
import RatesApi from '../../../openapi/src/api/RatesApi'
import DateRangePicker from '@/components/Inputs/DateRangePicker'
import AllotmentRow from '@/components/Allotment/AllotmentRow'

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0
}

function initScrollBlock() {
  if (hasElement('allotment-table')) {
    let table = document.getElementsByClassName('allotment-table')[0]
    table.addEventListener('scroll', function() {
      if (window.scrollY + window.innerHeight < document.body.scrollHeight) {
        window.scrollBy(0, this.scrollTop)
        table.scrollTo(this.scrollLeft, 0)
      }
    })
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollBlock()
    }, 100)
  }
}

const allotmentApi = new AllotmentApi()

/**
 * @deprecated Esta pagina esta deprecada
 */
export default {
  components: {
    AllotmentRow,
    AllotmentModal,
    RoomTypeSelect,
    ChannelSelect,
    RateSelect,
    DateRangePicker,
  },
  computed: {
    formattedFrom() {
      return this.moment(this.filters.travel_from).format('YYYY-MM-DD')
    },
    formattedTo() {
      return this.moment(this.filters.travel_to).format('YYYY-MM-DD')
    },
    days() {
      return this.visibleColumns.map((c) => {
        return {
          date: c.travel_date,
          occ: c.occupancy_percent,
        }
      })
    },
    isDirty() {
      return this.futureClass != null
    },
    rows() {
      return this.data.rows.map((row) => {
        let idx = 0

        row.columns.forEach((column) => {
          if (idx >= this.pageSize * this.page && idx < this.pageSize * this.page + this.pageSize) this.$set(column, 'visible', true)
          else this.$set(column, 'visible', false)

          idx++
        })

        return row
      })
    },
    isPrevPageDisabled() {
      return !(this.page > 0)
    },
    visibleColumns() {
      return this.rows[0].columns.filter((column) => column.visible)
    },
    isNextPageDisabled() {
      const columnsLength = this.rows[0].columns.length
      return !(columnsLength > (this.page + 1) * this.pageSize && columnsLength > this.pageSize)
    },
  },
  data() {
    return {
      watchersEnabled: false,
      data: null,
      filters: {
        travel_from: this.moment().toDate(),
        travel_to: this.moment().toDate(),
        room_type_ids: [],
        channel_ids: [],
        include_orr: false,
        include_tentative: false,
        include_guarantees: true,
        channels_online: true,
        rate_ids: [],
      },
      futureClass: null,
      selectionCounter: 0,
      liveModal: true,
      maxDays: 10,
      page: 0,
      pageSize: 10,
    }
  },
  methods: {
    isBeforeToday(date) {
      return date.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)
    },
    resetPage() {
      this.page = 0
    },
    prevPage() {
      this.page--
    },
    nextPage() {
      this.page++
    },
    setFutureLock: function(event) {
      this.futureClass = 'future-close'
    },
    setFutureUnlock: function(event) {
      this.futureClass = 'future-open'
    },
    allotmentSelected: function(allotment, room_type_id) {
      this.futureClass = null
      if (allotment.is_selected) {
        // eslint-disable-next-line
        this.$refs['modal'].addRoomTypeDate(room_type_id, allotment.travel_date)
        this.selectionCounter++
      } else {
        // eslint-disable-next-line
        this.$refs['modal'].removeRoomTypeDate(room_type_id, allotment.travel_date)
        this.selectionCounter--
      }
    },
    loadFromApi() {
      allotmentApi.getAllotmentCalendar(
        this.$root.hotelId,
        Object.assign(this.filters, {
          travel_from: this.formattedFrom,
          travel_to: this.formattedTo,
        }),
        (error, data) => {
          if (!error) {
            this.resetPage()

            const allotmentData = data

            allotmentData.rows.forEach((e) => {
              e.columns.forEach((ed) => {
                ed.value.originalAmount = ed.value.current_allotment
                ed.editable = !this.isBeforeToday(new Date(ed.travel_date))
              })
            })

            this.data = allotmentData

            this.selectionCounter = 0
            this.$refs['modal'].clearRoomTypeDate()
            setTimeout(() => {
              this.watchersEnabled = true
            }, 500)
            initScrollBlock()
          }
        }
      )
    },
    saveAdvanceAllotment(data) {
      if (data.range_dates == null) {
        //? data.room_type_ids = this.filters.room_type_ids;
        data.channel_ids = this.filters.channel_ids
        data.channels_online = this.filters.channels_online
        data.rate_ids = this.filters.rate_ids
      }
      var parsedData = AdvancedAllotmentActionRequestDTO.constructFromObject(data)

      if (!data.allotment_action.enabled) parsedData.allotment_action = null
      // eslint-disable-next-line
      if (!data.open_close_action_dto.enabled) parsedData.open_close_action_dto = null
      if (!data.mlos_action_dto.enabled) parsedData.mlos_action_dto = null
      allotmentApi.advancedAllotmentAction(this.$root.hotelId, parsedData)
      this.$notify({
        timeout: 4500,
        message: 'New allotments will be saved shortly',
        icon: 'check_box',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'info',
      })
    },
    clearSelection() {
      this.data.rows.forEach((r) => {
        r.columns.forEach((c) => {
          this.$set(c, 'is_selected', false)
        })
      })
    },
    async saveSimpleAllotments() {
      if (await this.$refs.validator.validate()) {
        var data = {}
        try {
          data = {
            channels_online: this.filters.channels_online,
            channel_ids: this.filters.channel_ids,
            rate_ids: this.filters.rate_ids,
            actions: this.data.rows.reduce((prev, row) => {
              return prev.concat(
                row.columns
                  .filter((c) => c.is_selected)
                  .filter((c) => c.visible)
                  .map((c) => {
                    this.$set(c, 'saved', true)
                    return SimpleAllotmentActionDTO.constructFromObject(
                      Object.assign(c, {
                        room_type_id: row.room_type_id,
                        // null if no action was clicked, true if close action was clicked
                        close: this.futureClass === null ? null : this.futureClass === 'future-close',
                        mlos: c.value.mlos_editable ? c.value.mlos[0].key : null,
                        allotment: c.value.current_allotment,
                      })
                    )
                  })
              )
            }, []),
          }
        } catch (e) {
          console.log(e)
        }
        if (data.actions.length) {
          allotmentApi.simpleAllotmentAction(this.$root.hotelId, SimpleAllotmentDTO.constructFromObject(data))
          this.$notify({
            timeout: 4500,
            message: 'New allotments will be saved shortly',
            icon: 'check_box',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'info',
          })
          this.clearSelection()
          this.futureClass = null
        } else {
          this.$notify({
            timeout: 5000,
            message: 'Nothing saved. Please select some action',
            icon: 'info',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'info',
          })
        }
      } else {
        this.$root.$emit('wrong-input')
      }
    },
    openAdvancedAllotment() {
      this.$refs['modal']
        .setChannelIds(this.filters.channel_ids)
        .setDateInterval(this.filters.travel_from, this.filters.travel_to)
        .open()
    },
    changeTravelDate(range) {
      this.filters.travel_from = range.start
      this.filters.travel_to = range.end

      const from = this.formattedFrom
      const to = this.formattedTo
      this.$router.replace(`${this.$route.path}?from=${from}&to=${to}`)
      location.reload()
    },
    isWeekend: function(d) {
      let dayOfWeek = this.moment(d).format('E')
      return dayOfWeek == 6 || dayOfWeek == 7
    },
  },
  created() {
    const from = this.$route.query.from ? this.moment(this.$route.query.from) : null

    if (from && from.isValid()) this.filters.travel_from = from.toDate()

    const to = this.$route.query.to ? this.moment(this.$route.query.to) : null

    if (to && to.isValid()) this.filters.travel_to = to.toDate()
    else
      this.filters.travel_to = this.moment()
        .add(this.maxDays, 'days')
        .toDate()

    let api = new RatesApi()
    api.getRates(this.$root.hotelId, (error, data) => {
      if (data.filter((t) => t['id'] == 'BAR').length > 0) {
        this.filters.rate_ids = ['BAR']
      }
      this.loadFromApi()
    })
  },
  watch: {
    'filters': {
      deep: true,
      handler: function() {
        if (this.watchersEnabled) {
          this.watchersEnabled = false
          this.loadFromApi()
        }
      },
    },
    'filters.channels_online': function() {
      this.filters.channel_ids = []
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/md/_variables.scss';

.allotment {
  .allotment-content .md-table-content {
    position: relative;
    overflow: auto;
  }
  .allotment-table {
    max-height: calc(100vh - 200px);

    table {
      position: relative;
      border-collapse: collapse;
      overflow: unset;
    }

    tr th:first-child {
      left: 0;
      z-index: 3;
    }

    tr th {
      position: -webkit-sticky; /* for Safari */
      position: sticky;
      top: -1px;
      z-index: 2;
      background-color: #ffffff;
    }
    tr td.fixed-cell {
      position: -webkit-sticky !important; /* for Safari */
      position: sticky !important;
      left: 0;
      z-index: 2;
      background-color: #ffffff;
    }
  }

  .md-table-head-label,
  .md-table-head-container {
    padding: 0;
    height: auto;
  }
  .md-table-row {
    display: table-row-group;
  }
  td {
    min-height: 1px;
  }
  .md-table-cell {
    padding: 1px;
    min-height: 1px;
  }
  .md-table-head-label {
    font-weight: 400;
  }
  .md-table-cell:not(.h6) {
    & .md-table-cell-container {
      display: table;
      height: 100px;
      width: 100%;
    }
    height: 100%;
    min-width: 157px !important;
    max-width: 157px !important;
  }
  .md-table-head-container {
    text-align: center;
  }

  .is-non-dirty {
    &.future-open .future-selected {
      background: rgb(76, 175, 80);
    }
    &.future-close .future-selected {
      background: #f44336;
    }
  }

  .weekend {
    background-color: #e8e8e8 !important;
  }

  .md-table-row:hover .md-table-cell:not(.weekend) {
    background-color: #ffffff !important;
  }
}

.content {
  padding-bottom: 0px !important;
}

.right {
  float: right;
}

.card-header {
  padding-bottom: 15px;
}

.arrow-button,
.arrow-button:hover,
.arrow-button.md-button .md-ripple {
  background: $brand-primary !important;
}

.arrow-button:hover {
  opacity: 0.95;
}
</style>
